export const GET_LIST = 'app/sessions/GET_LIST';
export const GET_LIST_COMPLETE = 'app/sessions/GET_LIST_COMPLETE';
export const GET_LIST_INCOMPLETE = 'app/sessions/GET_LIST_INCOMPLETE';
export const GET_SESSION_GROUPS = 'app/sessions/GET_SESSION_GROUPS';
export const GET_SESSION = 'app/sessions/GET_SESSION';
export const GET_SESSION_RESULTS = 'app/sessions/GET_SESSION_RESULTS';
export const GET_LICENSE = 'app/sessions/GET_LICENSE';
export const GET_NATIVE_PHOTOS = 'app/sessions/GET_NATIVE_PHOTOS';
export const CREATE_REQUEST = 'app/sessions/CREATE_REQUEST';
